import React, { Component } from 'react';
import Styles from './style.css';
import HeaderSignupOne from "../../components/header-signup-one/component";
import { BeatLoader } from 'react-spinners';
import { cartRegister } from "../../services/cartRegister";
import { dataRegister } from "../../services/dataRegister";
import { userRegister } from "../../services/userRegister";
import cx from "classnames";
import { langRegister } from "../../services/langRegister";
import { quotesRegister } from "../../services/quotesRegister";
import ReactGA from 'react-ga';
import ReactGA4 from 'react-ga4';
import ReactPixel from "react-facebook-pixel";
import { salesChannelRegister } from "../../services/salesChannelRegister";
import IndustrySearch from "../../components/industry-search/component";
import Faq from "../../components/faq/component";
import ErrorHandler from "../../components/error-handler/component";
import { tokenRegister } from "../../services/tokenRegister";
import { industriesRegister } from "../../services/industriesRegister";
import Cropper from 'react-cropper';
import 'cropperjs/dist/cropper.css';
import { scraperRegister } from "../../services/scraperRegister";
import BoosterHeader from "../../components/booster-header/component";
import ModalLeave from "../../components/modal-leave/component";
import ModalCropp from "../../components/modal-cropp/component";
import ModalImageSize from "../../components/modal-imagesize/component";
import { carouselRegister } from "../../services/carouselRegister";
import { videoRegister } from "../../services/videoRegister";
import ModalImageTags from "../../components/modal-imagetags/component";
import { flowRegister } from "../../services/flowRegister";
import { collectedRegister } from "../../services/collectedRegister";
import { imagesRegister } from "../../services/imagesRegister";
import { themeRegister } from "../../services/themeRegister";
import ModalImageAmount from "../../components/modal-imageamount/component";
import { yieldlockRegister } from "../../services/yieldlockRegister";
import ModalImageMaxTags from "../../components/modal-imagemaxtags/component";

class BoosterImage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            uploaded_images: [],
            scraped_images: [],
            tags: [],
            isLoading: true,
            uploaded_image: null,
            error: false,
            src: null,
            scraped: false,
            size_modal: false,
            scraper_images_boolean: true,
            prevent_manual_button: true
        };
        this.functions.uploadImage = this.functions.uploadImage.bind(this);
        this.functions.removeSizeModal = this.functions.removeSizeModal.bind(this);
    };

    componentWillMount() {

        window.scrollTo(0, 0);
        this.update.user();

        //GOOGLE ANALYTICS
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactGA.pageview('/booster/images');
            ReactGA4.send({ hitType: "pageview", page: "/booster/images" });
        }

        //FACEBOOK PIXEL
        if (dataRegister.api.primehit !== "https://api.devprimehit.com/v1") {
            ReactPixel.pageView();
        }

    }

    componentDidMount() {

        videoRegister.remove();
        this._updateCreativeView();

        //GET SCRAPER IMAGES AVAILABLE
        this.setState({
            scraper_images_boolean: scraperRegister.getImagesAvailableBoolean()
        });

        let token = tokenRegister.getToken();
        if (!token) {
            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang());
        }

    }

    _updateCreativeView() {
        try {
            if (window.location.search.indexOf("creative=manual") !== -1) {
                this.setState({ creativeView: "manual" });
            }
        } catch (e) {
        }
    }

    update = {
        tags: () => {
            let image_tags = [];
            let image_available_labels = {};

            if (flowRegister.getValue("image_tags")) {
                image_tags = JSON.parse(JSON.stringify(flowRegister.getValue("image_tags")));
            }
            if (flowRegister.getValue("image_available_labels")) {
                image_available_labels = JSON.parse(JSON.stringify(flowRegister.getValue("image_available_labels")));
            }
            this.setState({ tags: image_tags, available_labels: image_available_labels }, () => {
                this.update.data();
            });
        },
        user: () => {
            let user = userRegister.get();
            if (user) {
                this.setState({
                    reseller: user.reseller,
                    inhouse: user.inhouse
                }, () => {
                    this.update.tags();
                });
            } else {
                this.update.tags();
            }
        },
        data: () => {
            let images = imagesRegister.get();
            if (images.length > 0) {
                this.update.images(images);
            } else {
                this.setState({
                    isLoading: false,
                    prevent_manual_button: false
                });
            }
        },
        images: (images) => {

            let not_checked_images = [];
            let checked_images = [];

            for (let i = 0; i < images.length; i++) {
                if (!images[i].url && !images[i].date) {
                    if (!this.state.inhouse) {
                        if (i < 25) {
                            not_checked_images.push(images[i]);
                        }
                    } else {
                        not_checked_images.push(images[i]);
                    }
                } else {
                    checked_images.push(images[i]);
                }
            }
            this.setState({
                scraped_images: checked_images,
            }, async () => {

                function toDataUrl(src) {
                    return new Promise(function (resolve, reject) {
                        var img = new Image();
                        img.crossOrigin = 'Anonymous';
                        img.onload = function () {
                            var canvas = document.createElement('CANVAS');
                            var ctx = canvas.getContext('2d');
                            var dataURL;
                            canvas.height = this.naturalHeight;
                            canvas.width = this.naturalWidth;
                            ctx.drawImage(this, 0, 0);
                            dataURL = canvas.toDataURL('image/jpeg');
                            let object = { data_url: dataURL, web_url: src };
                            resolve(object);
                            canvas = null;
                        };
                        img.src = src;
                        if (img.complete || img.complete === undefined) {
                            // Flush cache
                            img.src = 'data:image/jpeg;base64,R0lGODlhAQABAIAAAAAAAP///ywAAAAAAQABAAACAUwAOw==';
                            // Try again
                            img.src = src;
                        }
                    });
                }

                let promises = [];
                for (let i = 0; i < not_checked_images.length; i++) {
                    if (!not_checked_images[i].date) {
                        promises.push(toDataUrl(not_checked_images[i]));
                    }
                }
                if (promises.length > 0) {
                    try {
                        Promise.all(promises).then((results) => {
                            for (let i = 0; i < results.length; i++) {
                                let image_object = {
                                    url: null,
                                    data_url: results[i].data_url,
                                    original: results[i].web_url,
                                    date: Math.floor(Math.random() * 999999999999999999999),
                                    isAnalyzing: true,
                                    isValid: false,
                                    scraped: true,
                                };
                                this.state.scraped_images.push(image_object);
                                let files = new FormData();
                                files.append('image', this.functions.dataURItoBlob(image_object.data_url));
                                dataRegister.analyzeImage(files).then((response) => {
                                    this.state.scraped_images = this.state.scraped_images.map((item) => {
                                        if (image_object.date === item.date) {
                                            delete item.data_url;
                                            item.isAnalyzing = false;
                                            item.isValid = response.valid;
                                            item.web_url = response.url;
                                            item.url = response.url;
                                            item.images = response.images;
                                            item.labels = response.labels;
                                            item.tag = "-1";
                                        }
                                        return item;
                                    });
                                    this.setState({
                                        scraped_images: this.state.scraped_images,
                                        prevent_manual_button: false
                                    }, () => {
                                        imagesRegister.set(this.state.scraped_images);
                                        this.functions.updateMultipleLabel();
                                    });
                                }, (error) => {
                                    this.state.scraped_images = this.state.scraped_images.map((item) => {
                                        if (image_object.date === item.date) {
                                            delete item.data_url;
                                            item.isAnalyzing = false;
                                            item.isValid = false;
                                            item.error = true;
                                        }
                                        return item;
                                    });
                                    this.setState({
                                        scraped_images: this.state.scraped_images,
                                        prevent_manual_button: false
                                    }, () => {
                                        imagesRegister.set(this.state.scraped_images);
                                    });
                                });
                            }
                            this.setState({
                                isLoading: false
                            });
                        }, (error) => {
                            this.setState({
                                isLoading: false
                            });
                        });
                    } catch (e) {
                        console.log(e);
                    }
                } else {
                    this.setState({
                        isLoading: false,
                        prevent_manual_button: false
                    });
                }
            });
        }
    };

    functions = {
        uploadImage: (e) => {
            console.log(e.target.files);
            try {
                if (e.target.files && e.target.files.length > 0 && e.target.files[0].type !== "video/mp4") {
                    if (e.target.files[0].size > 5999000) {
                        this.setState({ size_modal: true });
                    } else {
                        const reader = new FileReader();
                        reader.addEventListener("load", () => {
                            this.setState({ temp_src: reader.result, cropp_modal: true });
                        });
                        reader.readAsDataURL(e.target.files[0]);
                    }
                } else {

                }
            } catch (error) {
                console.log(error);
            }
        },
        setImageSrc: (option, close) => {
            if (!close) {
                if (!option) {
                    this.setState({ cropp_modal: false }, () => {
                        setTimeout(() => {
                            this.setState({ src: this.state.temp_src });
                        }, 300);
                    });
                } else {
                    let image_object = {
                        url: null,
                        data_url: this.state.temp_src,
                        date: Math.floor(Math.random() * 999999999999999999999),
                        description: "",
                        isAnalyzing: true,
                        isValid: false,
                        scraped: false
                    };
                    this.state.scraped_images.unshift(image_object);
                    this.setState({ scraped_images: this.state.scraped_images, src: null, cropp_modal: false }, () => {
                        let files = new FormData();
                        files.append('image', this.functions.dataURItoBlob(this.state.temp_src));
                        dataRegister.analyzeImage(files).then((response) => {
                            for (let i = 0; i < this.state.scraped_images.length; i++) {
                                if (image_object.date === this.state.scraped_images[i].date) {
                                    delete this.state.scraped_images[i].data_url;
                                    this.state.scraped_images[i].isAnalyzing = false;
                                    this.state.scraped_images[i].isValid = response.valid;
                                    this.state.scraped_images[i].url = response.url;
                                    this.state.scraped_images[i].web_url = response.url;
                                    this.state.scraped_images[i].original = response.url;
                                    this.state.scraped_images[i].images = response.images;
                                    this.state.scraped_images[i].labels = response.labels;
                                    image_object = this.state.scraped_images[i];
                                    break;
                                }
                            }
                            this.setState({ scraped_images: this.state.scraped_images, temp_src: null }, () => {
                                this.functions.updateSingleLabel(image_object);
                            });
                        }, (error) => {
                            for (let i = 0; i < this.state.scraped_images.length; i++) {
                                if (image_object.date === this.state.scraped_images[i].date) {
                                    delete this.state.scraped_images[i].data_url;
                                    this.state.scraped_images[i].isAnalyzing = false;
                                    this.state.scraped_images[i].isValid = false;
                                    this.state.scraped_images[i].error = true;
                                    image_object = this.state.scraped_images[i];
                                    break;
                                }
                            }
                            this.setState({
                                scraped_images: this.state.scraped_images,
                                temp_src: null,
                                src: null
                            }, () => {
                                imagesRegister.set(this.state.scraped_images);
                            });
                        });
                    });
                }
            } else {
                this.setState({ temp_src: null, cropp_modal: false });
            }
        },
        addCroppedImage: () => {
            let item = this.refs.cropper.getCroppedCanvas({
                fillColor: '#fff'
            }).toDataURL('image/jpeg');
            let image_object = {
                url: null,
                data_url: item,
                date: Math.floor(Math.random() * 999999999999999999999),
                description: "",
                isAnalyzing: true,
                isValid: false,
                scraped: false
            };
            this.state.scraped_images.unshift(image_object);
            this.setState({ scraped_images: this.state.scraped_images, src: null }, () => {
                let form_data = new FormData();
                let image_file = this.functions.dataURItoBlob(item);
                form_data.append('image', image_file);
                dataRegister.analyzeImage(form_data).then((response) => {
                    for (let i = 0; i < this.state.scraped_images.length; i++) {
                        if (image_object.date === this.state.scraped_images[i].date) {
                            delete this.state.scraped_images[i].data_url;
                            this.state.scraped_images[i].isAnalyzing = false;
                            this.state.scraped_images[i].isValid = response.valid;
                            this.state.scraped_images[i].url = response.url;
                            this.state.scraped_images[i].web_url = response.url;
                            this.state.scraped_images[i].original = response.url;
                            this.state.scraped_images[i].images = response.images;
                            this.state.scraped_images[i].labels = response.labels;
                            image_object = this.state.scraped_images[i];
                            break;
                        }
                    }
                    this.setState({ scraped_images: this.state.scraped_images }, () => {
                        this.functions.updateSingleLabel(image_object);
                    });
                }, (error) => {
                    for (let i = 0; i < this.state.scraped_images.length; i++) {
                        if (image_object.date === this.state.scraped_images[i].date) {
                            this.state.scraped_images[i].isAnalyzing = false;
                            this.state.scraped_images[i].isValid = false;
                            this.state.scraped_images[i].error = true;
                            image_object = this.state.scraped_images[i];
                            break;
                        }
                    }
                    this.setState({ scraped_images: this.state.scraped_images, temp_src: null, src: null }, () => {
                        imagesRegister.set(this.state.scraped_images);
                    });
                });
            });
        },
        updateSingleLabel: (item) => {
            let selected_labels = [];
            if (item.labels) {
                for (let i = 0; i < item.labels.length; i++) {
                    try {
                        if (this.state.available_labels[item.labels[i].description.toLowerCase()] && item.labels[i].score > this.state.available_labels[item.labels[i].description.toLowerCase()].score) {
                            item.labels[i].tag_id = this.state.available_labels[item.labels[i].description.toLowerCase()].id;
                            selected_labels.push(item.labels[i]);
                        }
                    } catch (e) {
                    }
                }
                if (selected_labels.length > 0) {
                    selected_labels = selected_labels.sort(function (a, b) {
                        if (b.score < a.score) {
                            return -1;
                        }
                        if (b.score > a.score) {
                            return 1;
                        }
                        return 0;
                    });
                    let label = selected_labels[0];
                    let tag = null;
                    for (let m = 0; m < this.state.tags.length; m++) {
                        if (label.tag_id === this.state.tags[m].id) {
                            tag = this.state.tags[m];
                            break;
                        }
                    }
                    for (let m = 0; m < this.state.scraped_images.length; m++) {
                        try {
                            if (this.state.scraped_images[m].label.id === tag.id) {
                                tag = null;
                                break;
                            }
                        } catch (e) {
                        }
                    }
                    if (tag) {
                        for (let m = 0; m < this.state.scraped_images.length; m++) {
                            if (this.state.scraped_images[m].date === item.date) {
                                this.state.scraped_images[m].tag = JSON.stringify(tag);
                                this.state.scraped_images[m].label = tag;
                                break;
                            }
                        }
                        this.setState({ scraped_images: this.state.scraped_images }, () => {
                            imagesRegister.set(this.state.scraped_images);
                        });
                    } else {
                        item.tag = '-1';
                        delete item.label;
                        this.setState({ scraped_images: this.state.scraped_images }, () => {
                            imagesRegister.set(this.state.scraped_images);
                        });
                    }
                } else {
                    item.tag = '-1';
                    delete item.label;
                    this.setState({ scraped_images: this.state.scraped_images }, () => {
                        imagesRegister.set(this.state.scraped_images);
                    });
                }
            }
        },
        updateMultipleLabel: () => {
            let scores = {};
            if (this.state.scraped_images.filter((item) => {
                return !item.isAnalyzing && item.date
            }).length === this.state.scraped_images.length) {
                let scraped_images = JSON.parse(JSON.stringify(this.state.scraped_images));
                console.log(scraped_images);
                for (let m = 0; m < scraped_images.length; m++) {
                    let selected_labels = [];
                    if (scraped_images[m].labels) {
                        for (let i = 0; i < scraped_images[m].labels.length; i++) {
                            try {
                                if (this.state.available_labels[scraped_images[m].labels[i].description.toLowerCase()] && scraped_images[m].labels[i].score > this.state.available_labels[scraped_images[m].labels[i].description.toLowerCase()].score) {
                                    selected_labels.push(this.state.scraped_images[m].labels[i]);
                                }
                            } catch (e) {
                                console.log(e);
                            }
                        }
                    }
                    if (selected_labels.length > 0) {
                        selected_labels = selected_labels.sort(function (a, b) {
                            if (b.score < a.score) {
                                return -1;
                            }
                            if (b.score > a.score) {
                                return 1;
                            }
                            return 0;
                        });
                        scraped_images[m].temp_label = selected_labels[0];
                        delete scraped_images[m].tag;
                    } else {
                        scraped_images[m].tag = "-1";
                    }
                }
                for (let i = 0; i < scraped_images.length; i++) {
                    try {
                        if (scraped_images[i].temp_label) {
                            if (scores[this.state.available_labels[scraped_images[i].temp_label.description.toLowerCase()].id]) {
                                if (scores[this.state.available_labels[scraped_images[i].temp_label.description.toLowerCase()].id].score < scraped_images[i].temp_label.score) {
                                    scores[this.state.available_labels[scraped_images[i].temp_label.description.toLowerCase()].id] = {
                                        score: scraped_images[i].temp_label.score,
                                        image_id: scraped_images[i].date
                                    };
                                }
                            } else {
                                scores[this.state.available_labels[scraped_images[i].temp_label.description.toLowerCase()].id] = {
                                    score: scraped_images[i].temp_label.score,
                                    image_id: scraped_images[i].date
                                };
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
                for (let i = 0; i < scraped_images.length; i++) {
                    try {
                        if (scraped_images[i].temp_label) {
                            if (scores[this.state.available_labels[scraped_images[i].temp_label.description.toLowerCase()].id].image_id === scraped_images[i].date) {
                                let tag = this.state.available_labels[scraped_images[i].temp_label.description.toLowerCase()];
                                delete tag.score;
                                scraped_images[i].tag = JSON.stringify(tag);
                                scraped_images[i].label = tag;
                                scraped_images[i].temp_label = null;
                            } else {
                                scraped_images[i].label = null;
                                scraped_images[i].temp_label = null;
                                scraped_images[i].tag = "-1";
                            }
                        }
                    } catch (e) {
                        console.log(e);
                    }
                }
                this.setState({
                    scraped_images: scraped_images
                }, () => {
                    imagesRegister.set(this.state.scraped_images);
                });
            }
        },
        selectUploadedImage: (item) => {
            try {
                console.log("selectUploadedImage !!!!!!!!!");
                if (item.isValid && !this.state.isSelecting) {
                    this.setState({ isSelecting: true }, () => {
                        let valid_images = [];
                        for (let i = 0; i < this.state.uploaded_images.length; i++) {
                            if (this.state.uploaded_images[i].date === item.date) {
                                this.state.uploaded_images[i].selected = true;
                                this.state.uploaded_images[i].tag = null;
                                this.state.uploaded_images[i].label = null;
                            } else {
                                this.state.uploaded_images[i].selected = false;
                            }
                            if (this.state.uploaded_images[i].isValid) {
                                valid_images.push(this.state.uploaded_images[i]);
                            }
                        }
                        cartRegister.setAdUploadedImages(valid_images);
                        cartRegister.setAdminImage(item);

                        //ADD TO THEME
                        try {
                            let theme_values = themeRegister.getValue();
                            theme_values.first_image = item.images.small;
                            themeRegister.setValue(theme_values);
                        } catch (e) {
                        }

                        this.setState({ uploaded_images: this.state.uploaded_images }, () => {
                            setTimeout(() => {
                                let view = quotesRegister.getView();
                                if (this.state.inhouse && this.state.creativeView === "manual") {
                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/video?creative=manual");
                                } else {
                                    if (view === "custom") {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
                                    } else {
                                        this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
                                    }
                                }
                            }, 200);
                        });
                    });
                }
            } catch (e) {
            }
        },
        selectScrapedImage: (item) => {
            try {
                if (item.isValid && this.renders.analyzingLoading() && !this.state.isSelecting) {

                    if (this.state.scraped_images.length < 26) {
                        if (this.state.scraped_images.filter((item) => {
                            return item.label
                        }).length < 4 && this.state.scraped_images.length > 4) {
                            this.setState({ item: item, tag_modal: true });
                        } else {
                            this.setState({ isSelecting: true, item: null }, () => {

                                let accepted_images = [];
                                let slogan_amenities = flowRegister.getValue("slogan_matches_revert");
                                let industry_amenities = collectedRegister.getValue("amenities_revert");

                                /*
                                let slogan_tags = [];
                                flowRegister.setValue("slogan_tags", slogan_tags);
                                */

                                for (let i = 0; i < this.state.scraped_images.length; i++) {
                                    this.state.scraped_images[i].selected = false;
                                    if (this.state.scraped_images[i].isValid) {
                                        if (item.date === this.state.scraped_images[i].date) {
                                            this.state.scraped_images[i].selected = true;
                                            this.state.scraped_images[i].tag = "-1";
                                            this.state.scraped_images[i].label = null;
                                        }
                                        accepted_images.push(this.state.scraped_images[i]);

                                        if (this.state.scraped_images[i].tag !== "-1") {
                                            //slogan_tags.push(this.state.scraped_images[i].label.title);
                                            slogan_amenities.push(this.state.scraped_images[i].label.title);
                                            //industry_amenities.push({"id": industry_amenities.length+i, "title": this.state.scraped_images[i].label.title, "selected": true});

                                            for (let key in industry_amenities) {
                                                if (industry_amenities[key].title === this.state.scraped_images[i].label.title) {
                                                    industry_amenities[key].selected = true;
                                                    break;
                                                }
                                            }

                                        }
                                    }
                                }

                         
                                collectedRegister.setValue("amenities", industry_amenities);
                                flowRegister.setValue("slogan_matches", slogan_amenities);
                                imagesRegister.set(accepted_images);
                                imagesRegister.setMain(item);
                                cartRegister.setAdminImage(item);

                                //ADD TO THEME
                                try {
                                    let theme_values = themeRegister.getValue();
                                    theme_values.first_image = item.images.small;
                                    themeRegister.setValue(theme_values);
                                } catch (e) {
                                }

                                this.setState({ scraped_images: this.state.scraped_images }, () => {
                                    setTimeout(() => {
                                        let view = quotesRegister.getView();
                                        if (this.state.inhouse && this.state.creativeView === "manual") {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/video?creative=manual");
                                        } else {
                                            if (view === "custom") {
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
                                            } else {
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
                                            }
                                        }
                                    }, 200);
                                })
                            });
                        }

                    } else {
                        this.setState({
                            amount_modal: true
                        })
                    }

                }
            } catch (e) {
                console.log(e);
            }
        },
        removeScrapedImage: (item) => {
            try {
                if (this.state.scraped_images.length > 1 && this.renders.analyzingLoading()) {
                    let label = item.label;
                    for (let i = 0; i < this.state.scraped_images.length; i++) {
                        if (item.url === this.state.scraped_images[i].url) {
                            this.state.scraped_images.splice(i, 1);
                            break;
                        }
                    }
                    this.setState({ scraped_images: this.state.scraped_images }, () => {
                        let images = [];
                        for (let i = 0; i < this.state.scraped_images.length; i++) {
                            images.push(this.state.scraped_images[i]);
                        }
                        if (images.length > 0) {
                            imagesRegister.set(images);
                        }
                        if (label) {
                            cartRegister.setVideoAd(null);
                        }
                    });
                }
            } catch (e) {
                console.log(e);
            }
        },
        removeUploadedImage: (item) => {
            try {
                let label = item.label;
                for (let i = 0; i < this.state.uploaded_images.length; i++) {
                    if (item.date === this.state.uploaded_images[i].date) {
                        this.state.uploaded_images.splice(i, 1);
                        break;
                    }
                }
                this.setState({ uploaded_images: this.state.uploaded_images }, () => {
                    cartRegister.setAdUploadedImages(this.state.uploaded_images);
                    cartRegister.setAdminImage(item);
                    if (label) {
                        cartRegister.setVideoAd(null);
                    }
                });
            } catch (e) {
            }
        },
        dataURItoBlob: (dataURI) => {
            try {
                var byteString;
                if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                    byteString = atob(dataURI.split(',')[1]);
                } else {
                    byteString = unescape(dataURI.split(',')[1]);
                }
                var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                var ia = new Uint8Array(byteString.length);
                for (var i = 0; i < byteString.length; i++) {
                    ia[i] = byteString.charCodeAt(i);
                }
                return new Blob([ia], { type: mimeString });
            } catch (e) {
                console.log(e);
            }
        },
        dataURItoBlobPromise: (dataURI) => {
            return new Promise(function (resolve, reject) {
                try {
                    var byteString;
                    if (dataURI.split(',')[0].indexOf('base64') >= 0) {
                        byteString = atob(dataURI.split(',')[1]);
                    } else {
                        byteString = unescape(dataURI.split(',')[1]);
                    }
                    var mimeString = dataURI.split(',')[0].split(':')[1].split(';')[0];
                    var ia = new Uint8Array(byteString.length);
                    for (var i = 0; i < byteString.length; i++) {
                        ia[i] = byteString.charCodeAt(i);
                    }
                    resolve(new Blob([ia], { type: mimeString }));
                } catch (e) {
                    console.log(e);
                }
            })
        },
        removeSizeModal: () => {
            this.setState({ size_modal: false })
        },
        removeTagModal: (item) => {
            console.log(item);

            if (item) {
                this.setState({ isSelecting: true }, () => {

                    let accepted_images = [];
                    let slogan_amenities = flowRegister.getValue("slogan_matches_revert");
                    let industry_amenities = collectedRegister.getValue("amenities_revert");

                    //let slogan_tags = [];
                    //flowRegister.setValue("slogan_tags", slogan_tags);

                    for (let i = 0; i < this.state.scraped_images.length; i++) {

                        this.state.scraped_images[i].selected = false;

                        if (this.state.scraped_images[i].isValid) {

                            if (item.date === this.state.scraped_images[i].date) {
                                this.state.scraped_images[i].selected = true;
                                this.state.scraped_images[i].tag = "-1";
                                this.state.scraped_images[i].label = null;
                            }
                            accepted_images.push(this.state.scraped_images[i]);

                            if (this.state.scraped_images[i].tag !== "-1") {
                                //slogan_tags.push(this.state.scraped_images[i].label.title);
                                if (Array.isArray(slogan_amenities)) {
                                    slogan_amenities.push(this.state.scraped_images[i].label.title);
                                }

                                //industry_amenities.push({"id": industry_amenities.length+i, "title": this.state.scraped_images[i].label.title, "selected": true});

                                for (let key in industry_amenities) {
                                    if (industry_amenities[key].title === this.state.scraped_images[i].label.title) {
                                        industry_amenities[key].selected = true;
                                    }
                                }

                            }

                        }
                    }

                    //console.log(JSON.stringify(slogan_tags));
                    //flowRegister.setValue("slogan_tags", slogan_tags);

                    if (slogan_amenities) {
                        flowRegister.setValue("slogan_matches", slogan_amenities);
                    }
                    if (industry_amenities) {
                        collectedRegister.setValue("amenities", industry_amenities);
                    }
                    imagesRegister.set(accepted_images);
                    cartRegister.setAdminImage(item);

                    //ADD TO THEME
                    try {
                        let theme_values = themeRegister.getValue();
                        theme_values.first_image = item.images.small;
                        themeRegister.setValue(theme_values);
                    } catch (e) {
                    }

                    this.setState({ scraped_images: this.state.scraped_images }, () => {
                        setTimeout(() => {
                            let view = quotesRegister.getView();
                            if (this.state.inhouse && this.state.creativeView === "manual") {
                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/video?creative=manual");
                            } else {
                                if (view === "custom") {
                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans-custom");
                                } else {
                                    this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/slogans");
                                }
                            }
                        }, 200);
                    })
                });
            } else {
                this.setState({ tag_modal: false });
            }
        },
        setTag: (tag, item) => {
            if (tag !== "-1") {
                let tagged_images = this.state.scraped_images.filter((item) => {
                    return item.tag && item.tag !== "-1" && item.label && item.tag !== tag;
                }).length;
                if (tagged_images < 7) {
                    for (let i = 0; i < this.state.scraped_images.length; i++) {
                        if (item.date === this.state.scraped_images[i].date) {
                            this.state.scraped_images[i].tag = tag;
                            this.state.scraped_images[i].label = JSON.parse(tag);
                        }
                    }
                    for (let i = 0; i < this.state.scraped_images.length; i++) {
                        try {
                            if (this.state.scraped_images[i].tag === tag && item.date !== this.state.scraped_images[i].date) {
                                this.state.scraped_images[i].tag = "-1";
                                this.state.scraped_images[i].label = null;
                            }
                        } catch (e) {
                        }
                    }
                } else {
                    this.setState({
                        max_tag_modal: true
                    })
                }
            } else {
                for (let i = 0; i < this.state.scraped_images.length; i++) {
                    if (item.date === this.state.scraped_images[i].date) {
                        this.state.scraped_images[i].tag = "-1";
                        delete this.state.scraped_images[i].label;
                    }
                }
            }
            this.setState({
                scraped_images: this.state.scraped_images
            }, () => {
                imagesRegister.set(this.state.scraped_images);
            });
        },
        setUploadedTag: (tag, item) => {
            let uploaded = JSON.parse(JSON.stringify(this.state.scraped_images));
            if (tag !== "-1") {
                let tagged_images = this.state.scraped_images.filter((item) => {
                    return item.tag && item.tag !== "-1" && item.label && item.tag !== tag;
                }).length;
                if (tagged_images < 7) {
                    for (let i = 0; i < uploaded.length; i++) {
                        if (item.date === uploaded[i].date) {
                            uploaded[i].tag = tag;
                            uploaded[i].label = JSON.parse(tag);
                        }
                    }
                    for (let i = 0; i < uploaded.length; i++) {
                        try {
                            if (uploaded[i].tag === tag && item.date !== uploaded[i].date) {
                                uploaded[i].tag = "-1";
                                uploaded[i].label = null;
                            }
                        } catch (e) { }
                    }
                } else {
                    this.setState({
                        max_tag_modal: true
                    })
                }
            } else {
                for (let i = 0; i < uploaded.length; i++) {
                    if (item.date === uploaded[i].date) {
                        uploaded[i].tag = "-1";
                        uploaded[i].label = null;
                    }
                }
            }
            this.setState({
                scraped_images: uploaded
            }, () => {
                imagesRegister.set(this.state.scraped_images);
                cartRegister.setVideoAd(null);
            });
        }
    };

    renders = {
        text: (item) => {
            return langRegister.get("signup-image", item);
        },
        label: (item) => {
            try {
                return item.title ? item.title : item.description
            } catch (e) {
                return "Add tag"
            }
        },
        analyzingLoading: () => {
            try {
                return ((this.state.scraped_images.length > 0 && this.state.scraped_images.filter((item) => {
                    return !item.isAnalyzing
                }).length === this.state.scraped_images.length) || (this.state.scraped_images.length < 1 && !this.state.prevent_manual_button));
            } catch (e) {
                return false
            }
        },
        uploadedImage: (item) => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    {
                        !item.isAnalyzing && item.isValid && !item.error &&
                        <div className={
                            cx(Styles.imagesContainerItemLabel,
                                {
                                    [Styles.imagesContainerItemLabelYieldlock]: (item.tag && item.tag !== "-1") && salesChannelRegister.get('name') === 'yieldlock',
                                    [Styles.imagesContainerItemLabelGrey]: (!item.tag || item.tag === "-1"),
                                    [Styles.imagesContainerItemLabelGreyYieldlock]: (!item.tag || item.tag === "-1") && salesChannelRegister.get('name') === 'yieldlock',
                                })
                        }>
                            {
                                item.tag && item.tag !== "-1" &&
                                <span>{this.renders.label(item.label)}</span>
                            }
                            {
                                (!item.tag || item.tag === "-1") &&
                                <span>{this.renders.text("item_37")}</span>
                            }
                            <select
                                value={item.tag}
                                className={Styles.dropdownSelection}
                                onChange={(event) => this.functions.setUploadedTag(event.target.value, item)}
                            >
                                {
                                    (item.tag && item.tag === "-1") &&
                                    <option value="-1">{this.renders.text("item_50")}</option>
                                }
                                {
                                    (item.tag && item.tag !== "-1") &&
                                    <option value="-1">{this.renders.text("item_42")}</option>
                                }
                                {
                                    this.state.tags.map((item) => {
                                        return (
                                            <option className={Styles.imagesContainerItemLabelDropdownItem}
                                                value={JSON.stringify(item)}>{item.title}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    }
                    {
                        item.isAnalyzing &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={Styles.imagesContainerItemOverlayText}>
                                <BeatLoader size={20} color={'var(--first-color)'} loading={true} />
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                    className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_38")}</div>
                            </div>
                        </div>
                    }
                    {
                        !item.isAnalyzing && !item.isValid && !item.error &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={cx(Styles.imagesContainerItemOverlayText,
                                {
                                    [Styles.imagesContainerItemOverlayTextError]: salesChannelRegister.get("name") !== "yieldlock",
                                    [Styles.imagesContainerItemOverlayTextErrorYieldlock]: salesChannelRegister.get("name") === "yieldlock",
                                })
                            }>
                                {this.renders.text("item_39")}
                            </div>
                        </div>
                    }
                    {
                        !item.isAnalyzing && item.error &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={cx(Styles.imagesContainerItemOverlayText,
                                {
                                    [Styles.imagesContainerItemOverlayTextError]: salesChannelRegister.get("name") !== "yieldlock",
                                    [Styles.imagesContainerItemOverlayTextErrorYieldlock]: salesChannelRegister.get("name") === "yieldlock",
                                })
                            }>
                                {this.renders.text("item_40")}
                            </div>
                        </div>
                    }
                    <div onClick={() => this.functions.selectScrapedImage(item)}
                        className={Styles.imagesContainerItemInner}>
                        <div style={{ backgroundImage: "url(" + item.url + ")" }}
                            className={cx(Styles.imagesContainerItemInnerUploadImage, Styles.imagesContainerItemInnerOwnUpload)} />
                        {
                            item.selected &&
                            <div
                                style={salesChannelRegister.get('name') === 'yieldlock' ? { borderColor: '#E65032' } : {}}
                                className={Styles.imagesContainerItemActive} />
                        }
                    </div>
                    {
                        !item.isAnalyzing &&
                        <div onClick={() => this.functions.removeScrapedImage(item)}
                            className={Styles.imagesContainerItemRemove}
                            style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#E65032' } : {}}>
                            <img className={Styles.imagesContainerItemRemoveItem}
                                src={require('../../assets/images/AB_cross_bold.png')} />
                        </div>
                    }
                </div>
            )
        },
        scrapedImage: (item) => {
            return (
                <div className={cx(Styles.imagesContainerItem)}>
                    {
                        !item.isAnalyzing && item.isValid && !item.error && this.renders.analyzingLoading() &&
                        <div className={
                            cx(Styles.imagesContainerItemLabel,
                                {
                                    [Styles.imagesContainerItemLabelYieldlock]: (item.tag && item.tag !== "-1") && salesChannelRegister.get('name') === 'yieldlock',
                                    [Styles.imagesContainerItemLabelGrey]: (!item.tag || item.tag === "-1"),
                                    [Styles.imagesContainerItemLabelGreyYieldlock]: (!item.tag || item.tag === "-1") && salesChannelRegister.get('name') === 'yieldlock',
                                })
                        }>
                            {
                                item.tag && item.tag !== "-1" &&
                                <span>{this.renders.label(item.label)}</span>
                            }
                            {
                                (!item.tag || item.tag === "-1") &&
                                <span>{this.renders.text("item_37")}</span>
                            }
                            <select
                                value={item.tag}
                                className={Styles.dropdownSelection}
                                onChange={(event) => this.functions.setTag(event.target.value, item)}
                            >
                                {
                                    (item.tag && item.tag === "-1") &&
                                    <option value="-1">{this.renders.text("item_50")}</option>
                                }
                                {
                                    (item.tag && item.tag !== "-1") &&
                                    <option value="-1">{this.renders.text("item_42")}</option>
                                }
                                {
                                    this.state.tags.map((item) => {
                                        return (
                                            <option className={Styles.imagesContainerItemLabelDropdownItem}
                                                value={JSON.stringify(item)}>{item.title}</option>
                                        )
                                    })
                                }
                            </select>
                        </div>
                    }
                    {
                        item.isAnalyzing &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={Styles.imagesContainerItemOverlayText}>
                                <BeatLoader size={20} color={'var(--first-color)'} loading={true} />
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                    className={Styles.imagesContainerItemOverlayTextInner}>{this.renders.text("item_38")}</div>
                            </div>
                        </div>
                    }
                    {
                        !item.isAnalyzing && !item.isValid && !item.error &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={cx(Styles.imagesContainerItemOverlayText,
                                {
                                    [Styles.imagesContainerItemOverlayTextError]: salesChannelRegister.get("name") !== "yieldlock",
                                    [Styles.imagesContainerItemOverlayTextErrorYieldlock]: salesChannelRegister.get("name") === "yieldlock",
                                })
                            }>
                                {this.renders.text("item_39")}
                            </div>
                        </div>
                    }
                    {
                        !item.isAnalyzing && item.error &&
                        <div className={Styles.imagesContainerItemOverlay}>
                            <div className={cx(Styles.imagesContainerItemOverlayText,
                                {
                                    [Styles.imagesContainerItemOverlayTextError]: salesChannelRegister.get("name") !== "yieldlock",
                                    [Styles.imagesContainerItemOverlayTextErrorYieldlock]: salesChannelRegister.get("name") === "yieldlock",
                                })
                            }>
                                {this.renders.text("item_40")}
                            </div>
                        </div>
                    }
                    <div onClick={() => this.functions.selectScrapedImage(item)}
                        className={Styles.imagesContainerItemInner}>
                        <div style={{ backgroundImage: "url(" + item.url + ")" }}
                            className={Styles.imagesContainerItemInnerUploadImage} />
                        {
                            item.selected &&
                            <div
                                style={salesChannelRegister.get('name') === 'yieldlock' ? { borderColor: '#E65032' } : {}}
                                className={Styles.imagesContainerItemActive} />
                        }
                    </div>
                    {
                        this.state.scraped_images.length > 1 && !item.isAnalyzing && this.renders.analyzingLoading() &&
                        <div onClick={() => this.functions.removeScrapedImage(item)}
                            className={Styles.imagesContainerItemRemove}
                            style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#E65032' } : {}}>
                            <img className={Styles.imagesContainerItemRemoveItem}
                                src={require('../../assets/images/AB_cross_bold.png')} />
                        </div>
                    }
                </div>
            )
        },
        uploadButton: () => {
            return (
                <div className={
                    cx(Styles.imagesContainerItem,
                        {
                            [Styles.imagesContainerItemCenter]: this.state.scraped_images.length < 1,
                        })
                }>
                    <div className={Styles.imagesContainerItemInner}>
                        <div style={salesChannelRegister.get('name') === 'yieldlock' ? {} : {}}
                            className={Styles.imagesContainerItemInnerIcon}>+
                        </div>
                    </div>
                    <input ref="uploadImageFile" onClick={() => this.refs.uploadImageFile.value = null}
                        onChange={(e) => this.functions.uploadImage(e)} type="file"
                        accept="image/gif, image/jpeg, image/png, video/mp4"
                        className={Styles.imagesContainerItemInnerUpload} />
                </div>
            )
        }
    };

    render() {
        return (
            <div>
                <BoosterHeader images={this.state.scraped_images.length} analyzing={this.renders.analyzingLoading()}
                    props={this.props} />
                {
                    this.state.cropp_modal &&
                    <ModalCropp setLeave={this.functions.setImageSrc} />
                }
                {
                    this.state.size_modal &&
                    <ModalImageSize setLeave={this.functions.removeSizeModal} />
                }
                {
                    this.state.amount_modal &&
                    <ModalImageAmount amount={(this.state.scraped_images.length - 25)} setLeave={() => {
                        this.setState({
                            amount_modal: false
                        })
                    }} />
                }
                {
                    this.state.tag_modal &&
                    <ModalImageTags item={this.state.item} setLeave={this.functions.removeTagModal} />
                }
                {
                    this.state.max_tag_modal &&
                    <ModalImageMaxTags setLeave={() => {
                        this.setState({
                            max_tag_modal: false
                        })
                    }} />
                }
                {
                    this.state.src &&
                    <div className={Styles.overlayCopper}>
                        <div className={Styles.overlayModalCrop}>
                            {
                                <Cropper
                                    ref='cropper'
                                    modal={false}
                                    src={this.state.src}
                                    aspectRatio={300 / 157}
                                    guides={false}
                                    background={false}
                                    zoomOnWheel={false}
                                    viewMode={1}
                                    scalable={false}
                                    dragMode={'none'}
                                    style={{ height: 400, width: '100%' }}
                                />
                            }
                            <div className={Styles.overlayModalCropButtons}>
                                <div className={Styles.overlayModalCropButtonsInner}>
                                    <div onClick={() => {
                                        this.setState({ src: null })
                                    }}
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#00273A' } : {}}
                                        className={Styles.overlayModalCropButtonsItemRemove}>
                                        <img className={Styles.overlayModalCropButtonsItemRemoveIcon}
                                            src={require("../../assets/images/AB_cross_bold.png")} />
                                    </div>
                                    <div
                                        style={salesChannelRegister.get('name') === 'yieldlock' ? { backgroundColor: '#E65032' } : {}}
                                        onClick={() => this.functions.addCroppedImage()}
                                        className={Styles.overlayModalCropButtonsItemSelect}>
                                        <img className={Styles.overlayModalCropButtonsItemSelectIcon}
                                            src={require("../../assets/images/AB_checkmark_bold.png")} />
                                    </div>
                                    {
                                        false &&
                                        <div
                                            style={{ backgroundColor: '#BFBFBF', marginLeft: "17px" }}
                                            onClick={() => {
                                                this.refs.cropper.reset();
                                            }}
                                            className={Styles.overlayModalCropButtonsItemSelect}>
                                            <img style={{ width: "22px" }}
                                                src={require("../../assets/images/reset-icon.svg")} />
                                        </div>
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                }
                {
                    !this.state.isLoading && !this.state.error &&
                    <div className={Styles.containerOuter}>
                        <div className={Styles.container}>
                            {
                                !this.state.error && this.state.scraped_images.length > 0 && this.state.scraped_images.length < 26 &&
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                    className={Styles.title}>
                                    {this.renders.text("item_43")}
                                </div>
                            }
                            {
                                !this.state.error && this.state.scraped_images.length > 25 &&
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                    className={Styles.title}>
                                    {this.renders.text("item_44")}{" "}{this.state.scraped_images.length - 25}{" "}{this.renders.text("item_45")}
                                    {
                                        false &&
                                        <div className={Styles.titleSmall}>
                                            <div className={Styles.titleSmallTags}>
                                                {
                                                    this.state.tags.map((item) => {
                                                        return (
                                                            <div className={Styles.titleSmallTag}>{item.title}</div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {this.renders.text("item_46")}
                                        </div>
                                    }
                                </div>
                            }
                            {
                                !this.state.error && this.state.scraped_images.length < 1 &&
                                <div style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                    className={Styles.title}>
                                    {this.renders.text("item_47")}
                                    {
                                        this.state.uploaded_images.length > 0 && false &&
                                        <div className={Styles.titleSmall}>
                                            <div className={Styles.titleSmallTags}>
                                                {
                                                    this.state.tags.map((item) => {
                                                        return (
                                                            <div className={Styles.titleSmallTag}>{item.title}</div>
                                                        )
                                                    })
                                                }
                                            </div>
                                            {this.renders.text("item_48")}
                                        </div>
                                    }
                                </div>
                            }
                            {
                                !this.state.modal &&
                                <div className={
                                    cx(Styles.imagesContainer,
                                        {
                                            [Styles.imagesContainerCenter]: this.state.scraped_images.length < 1,
                                        })
                                }>
                                    {
                                        ((this.state.inhouse && this.state.creativeView === "manual") || (!this.state.inhouse && !this.state.scraper_images_boolean)) &&
                                        this.renders.uploadButton()
                                    }
                                    {
                                        this.state.scraped_images.map((item) => {
                                            if (item.scraped) {
                                                return (
                                                    this.renders.scrapedImage(item)
                                                )
                                            } else {
                                                return (
                                                    this.renders.uploadedImage(item)
                                                )
                                            }
                                        })
                                    }
                                </div>
                            }
                            {
                                <div
                                    onClick={() => {
                                        if (salesChannelRegister.get("name") === "yieldlock") {
                                            if (this.state.inhouse && yieldlockRegister.getValue("manual")) {
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/calculator?creative=manual");
                                            } else {
                                                this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/calculator");
                                            }
                                        } else {
                                            this.props.history.push("/" + salesChannelRegister.get('market') + "/" + langRegister.lang() + "/booster/industry");
                                        }
                                    }}
                                    style={salesChannelRegister.get('name') === 'yieldlock' ? { color: '#00273A' } : {}}
                                    className={
                                        cx(Styles.backButton,
                                            {
                                                [Styles.backButtonCenter]: (this.state.scraped_images.length < 1),
                                            })
                                    }>
                                    {this.renders.text("item_29")}
                                </div>
                            }
                        </div>
                    </div>
                }
                {
                    this.state.isLoading &&
                    <div className={Styles.loader}>
                        <BeatLoader size={30} color={'var(--first-color)'} loading={true} />
                    </div>
                }
                {
                    !this.state.isLoading && this.state.error &&
                    <div className={Styles.loader}>
                        <ErrorHandler props={this.props} />
                    </div>
                }
            </div>
        );
    }
}

export default BoosterImage;


// WEBPACK FOOTER //
// ./src/pages/booster-images/component.js